/* WARNING: This file is auto-generated . Do not edit manually. */

import { HostingWebDatabaseExtraSqlQuotaEnum } from '../models/HostingWebDatabaseExtraSqlQuotaEnum';
import { HostingWebLocalSeoDirectoriesList } from '../models/HostingWebLocalSeoDirectoriesList';
import { HostingWebOwnLogs } from '../models/HostingWebOwnLogs';
import { HostingWebTask } from '../models/HostingWebTask';
import { HostingWebDatabaseStatisticsTypeEnum } from '../models/HostingWebDatabaseStatisticsTypeEnum';
import { HostingWebLocalSeoLocation } from '../models/HostingWebLocalSeoLocation';
import { HostingWebDatabaseDumpDateEnum } from '../models/HostingWebDatabaseDumpDateEnum';
import { HostingWebEmailoption } from '../models/HostingWebEmailoption';
import { HostingWebDatabaseCreationDatabaseCapabilities } from '../models/HostingWebDatabaseCreationDatabaseCapabilities';
import { HostingWebBoostHistory } from '../models/HostingWebBoostHistory';
import { HostingWebMailBounce } from '../models/HostingWebMailBounce';
import { HostingWebConfiguration } from '../models/HostingWebConfiguration';
import { CdnDomainStatisticsPeriodEnum } from '../models/CdnDomainStatisticsPeriodEnum';
import { HostingWebBackupTypeEnum } from '../models/HostingWebBackupTypeEnum';
import { HostingWebOvhConfigHttpFirewallEnum } from '../models/HostingWebOvhConfigHttpFirewallEnum';
import { HostingWebSSL } from '../models/HostingWebSSL';
import { ServiceTerminationFutureUseEnum } from '../models/ServiceTerminationFutureUseEnum';
import { HostingWebStatisticsPeriodEnum } from '../models/HostingWebStatisticsPeriodEnum';
import { HostingWebDatabaseDatabaseTypeEnum } from '../models/HostingWebDatabaseDatabaseTypeEnum';
import { HostingWebSslReport } from '../models/HostingWebSslReport';
import { HostingWebCapabilities } from '../models/HostingWebCapabilities';
import { HostingWebService } from '../models/HostingWebService';
import { HostingWebUser } from '../models/HostingWebUser';
import { HostingWebRuntime } from '../models/HostingWebRuntime';
import { HostingWebRequestActionEnum } from '../models/HostingWebRequestActionEnum';
import { HostingWebOvhConfigCapabilities } from '../models/HostingWebOvhConfigCapabilities';
import { HostingWebOvhConfigAvailableEngineVersionEnum } from '../models/HostingWebOvhConfigAvailableEngineVersionEnum';
import { HostingWebDatabaseDatabaseCapabilities } from '../models/HostingWebDatabaseDatabaseCapabilities';
import { HostingWebRuntimeTypeEnum } from '../models/HostingWebRuntimeTypeEnum';
import { HostingWebCdn } from '../models/HostingWebCdn';
import { HostingWebUserLogs } from '../models/HostingWebUserLogs';
import { HostingWebAttachedDomainCdnEnum } from '../models/HostingWebAttachedDomainCdnEnum';
import { HostingWebDatabaseRequestActionEnum } from '../models/HostingWebDatabaseRequestActionEnum';
import { CdnDomainStatistics } from '../models/CdnDomainStatistics';
import { ServiceTerminationReasonEnum } from '../models/ServiceTerminationReasonEnum';
import { CdnDomainOption } from '../models/CdnDomainOption';
import { CdnPurgeTypeEnum } from '../models/CdnPurgeTypeEnum';
import { HostingWebAttachedDomain } from '../models/HostingWebAttachedDomain';
import { HostingWebDatabaseVersionEnum } from '../models/HostingWebDatabaseVersionEnum';
import { HostingWebModule } from '../models/HostingWebModule';
import { HostingWebModuleDependencyType } from '../models/HostingWebModuleDependencyType';
import { HostingWebDatabaseModeEnum } from '../models/HostingWebDatabaseModeEnum';
import { HostingPrivateDatabaseAvailableRamSizeEnum } from '../models/HostingPrivateDatabaseAvailableRamSizeEnum';
import { ServicesService } from '../models/ServicesService';
import { HostingWebEmail } from '../models/HostingWebEmail';
import { CdnAvailableOptions } from '../models/CdnAvailableOptions';
import { HostingWebPublicTask } from '../models/HostingWebPublicTask';
import { HostingWebLocalSeoVisibilityCheckResultResponse } from '../models/HostingWebLocalSeoVisibilityCheckResultResponse';
import { HostingWebCron } from '../models/HostingWebCron';
import { HostingWebEnvVarTypeEnum } from '../models/HostingWebEnvVarTypeEnum';
import { HostingWebMailVolumeHistory } from '../models/HostingWebMailVolumeHistory';
import { HostingWebDump } from '../models/HostingWebDump';
import { HostingWebModuleList } from '../models/HostingWebModuleList';
import { HostingWebLocalSeoLocationCountryEnum } from '../models/HostingWebLocalSeoLocationCountryEnum';
import { HostingWebOvhConfig } from '../models/HostingWebOvhConfig';
import { HostingWebEnvVar } from '../models/HostingWebEnvVar';
import { HostingWebModuleLanguageEnum } from '../models/HostingWebModuleLanguageEnum';
import { CdnLogs } from '../models/CdnLogs';
import { HostingWebLocalSeoVisibilityCheckResponse } from '../models/HostingWebLocalSeoVisibilityCheckResponse';
import { HostingWebMailActionEnum } from '../models/HostingWebMailActionEnum';
import { HostingWebConfigurationVersionEnum } from '../models/HostingWebConfigurationVersionEnum';
import { HostingWebTaskStatusEnum } from '../models/HostingWebTaskStatusEnum';
import { HostingWebUserSshStateEnum } from '../models/HostingWebUserSshStateEnum';
import { HostingWebDatabaseDatabaseCapabilitiesTypeEnum } from '../models/HostingWebDatabaseDatabaseCapabilitiesTypeEnum';
import { HostingWebOvhConfigEnvironmentEnum } from '../models/HostingWebOvhConfigEnvironmentEnum';
import { HostingWebStatisticsTypeEnum } from '../models/HostingWebStatisticsTypeEnum';
import { CdnDomainAddOption } from '../models/CdnDomainAddOption';
import { HostingWebDatabase } from '../models/HostingWebDatabase';
import { CdnDomain } from '../models/CdnDomain';
import { HostingWebLocalSeoEmailAvailability } from '../models/HostingWebLocalSeoEmailAvailability';
import { HostingWebLocalSeoAccount } from '../models/HostingWebLocalSeoAccount';
import { HostingWebIndy } from '../models/HostingWebIndy';
import { HostingWebFreedomStatusEnum } from '../models/HostingWebFreedomStatusEnum';
import { HostingWebConfigurationLanguageEnum } from '../models/HostingWebConfigurationLanguageEnum';
import { HostingWebOvhConfigRecommendedValues } from '../models/HostingWebOvhConfigRecommendedValues';
import { HostingWebAttachedDomainFirewallEnum } from '../models/HostingWebAttachedDomainFirewallEnum';
import { CdnOperation } from '../models/CdnOperation';
import { HostingWebDatabaseDatabaseCreationTypeEnum } from '../models/HostingWebDatabaseDatabaseCreationTypeEnum';
import { HostingWebOvhConfigEngineNameEnum } from '../models/HostingWebOvhConfigEngineNameEnum';
import { HostingPrivateDatabaseOrderableVersionEnum } from '../models/HostingPrivateDatabaseOrderableVersionEnum';
import { ServiceRenewType } from '../models/ServiceRenewType';
import { HostingWebExtrasqlperso } from '../models/HostingWebExtrasqlperso';
import { ComplexTypeChartTimestampValue } from '../models/ComplexTypeChartTimestampValue';
import { HostingWebOfferCapabilitiesEnum } from '../models/HostingWebOfferCapabilitiesEnum';
import { HostingWebModuleBranchEnum } from '../models/HostingWebModuleBranchEnum';
import { HostingWebDatabaseAvailableVersionStruct } from '../models/HostingWebDatabaseAvailableVersionStruct';
import { HostingWebLanguagesEnum } from '../models/HostingWebLanguagesEnum';
import { HostingWebFreedom } from '../models/HostingWebFreedom';
import { HostingWebOvhconfigContainerEnum } from '../models/HostingWebOvhconfigContainerEnum';
import { HostingWebOfferEnum } from '../models/HostingWebOfferEnum';
import { HostingWebRuntimeEnvEnum } from '../models/HostingWebRuntimeEnvEnum';
import { HostingWebLocalSeoLocationOfferEnum } from '../models/HostingWebLocalSeoLocationOfferEnum';
import { HostingWebDatabaseDump } from '../models/HostingWebDatabaseDump';
import OVHBase from '../ovh';

class HostingWebHandler {
  ovh: OVHBase;

  constructor(ovh: OVHBase) {
    this.ovh = ovh;
  }

  /** List available services */
  listWeb = (): Promise<string[]> => {
    return this.ovh.request('GET', '/hosting/web');
  };

  /** Find hosting service linked to a domain */
  getWebAttachedDomain = (): Promise<string[]> => {
    return this.ovh.request('GET', '/hosting/web/attachedDomain');
  };

  /** Get available offer */
  getWebAvailableOffer = (): Promise<HostingWebOfferEnum[]> => {
    return this.ovh.request('GET', '/hosting/web/availableOffer');
  };

  /** Get current incident */
  getWebIncident = (): Promise<string[]> => {
    return this.ovh.request('GET', '/hosting/web/incident');
  };

  /** Get list of directories associated to a local SEO offer and a country */
  getWebLocalSeoDirectoriesList = (): Promise<HostingWebLocalSeoDirectoriesList> => {
    return this.ovh.request('GET', '/hosting/web/localSeo/directoriesList');
  };

  /** Check email availability for a local SEO order */
  checkWebLocalSeoEmailAvailability = (): Promise<HostingWebLocalSeoEmailAvailability> => {
    return this.ovh.request('GET', '/hosting/web/localSeo/emailAvailability');
  };

  /** Check visibility of a location */
  checkWebLocalSeoVisibility = (body: {
    country: HostingWebLocalSeoLocationCountryEnum;
    name: string;
    street: string;
    zip: string;
  }): Promise<HostingWebLocalSeoVisibilityCheckResponse> => {
    return this.ovh.request('POST', '/hosting/web/localSeo/visibilityCheck', body);
  };

  /** Get the result of a visibility check */
  getWebLocalSeoVisibilityCheckResult = (): Promise<
    HostingWebLocalSeoVisibilityCheckResultResponse[]
  > => {
    return this.ovh.request('GET', '/hosting/web/localSeo/visibilityCheckResult');
  };

  /** IDs of all modules available */
  getWebModuleList = (): Promise<number[]> => {
    return this.ovh.request('GET', '/hosting/web/moduleList');
  };

  /** Get this object properties */
  getWebModuleListById = (id: number): Promise<HostingWebModuleList> => {
    return this.ovh.request('GET', `/hosting/web/moduleList/${id}`);
  };

  /** Get offer capabilities */
  getWebOfferCapabilities = (): Promise<HostingWebCapabilities> => {
    return this.ovh.request('GET', '/hosting/web/offerCapabilities');
  };

  /** Get this object properties */
  getWebByServiceName = (serviceName: string): Promise<HostingWebService> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}`);
  };

  /** Alter this object properties */
  updateWebByServiceName = (serviceName: string, body: HostingWebService): Promise<void> => {
    return this.ovh.request('PUT', `/hosting/web/${serviceName}`, body);
  };

  /** Activate an included private database on your hosting offer */
  postWebActivatePrivateDatabaseByServiceName = (
    serviceName: string,
    body: {
      ram: HostingPrivateDatabaseAvailableRamSizeEnum;
      version: HostingPrivateDatabaseOrderableVersionEnum;
    }
  ): Promise<HostingWebTask> => {
    return this.ovh.request('POST', `/hosting/web/${serviceName}/activatePrivateDatabase`, body);
  };

  /** Domains or subdomains attached to your hosting */
  getWebAttachedDomainByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/attachedDomain`);
  };

  /** Link a domain to this hosting */
  postWebAttachedDomainByServiceName = (
    serviceName: string,
    body: {
      cdn?: HostingWebAttachedDomainCdnEnum;
      domain: string;
      firewall?: HostingWebAttachedDomainFirewallEnum;
      ownLog?: string;
      path: string;
      runtimeId?: number;
      ssl?: boolean;
    }
  ): Promise<HostingWebTask> => {
    return this.ovh.request('POST', `/hosting/web/${serviceName}/attachedDomain`, body);
  };

  /** Unlink domain from hosting */
  deleteWebAttachedDomainByServiceNameAndDomain = (
    domain: string,
    serviceName: string
  ): Promise<HostingWebTask> => {
    return this.ovh.request('DELETE', `/hosting/web/${serviceName}/attachedDomain/${domain}`);
  };

  /** Get this object properties */
  getWebAttachedDomainByServiceNameAndDomain = (
    domain: string,
    serviceName: string
  ): Promise<HostingWebAttachedDomain> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/attachedDomain/${domain}`);
  };

  /** Alter this object properties */
  updateWebAttachedDomainByServiceNameAndDomain = (
    domain: string,
    serviceName: string,
    body: HostingWebAttachedDomain
  ): Promise<void> => {
    return this.ovh.request('PUT', `/hosting/web/${serviceName}/attachedDomain/${domain}`, body);
  };

  /** Purge cache for this attached domain */
  postWebAttachedDomainPurgeCacheByServiceNameAndDomain = (
    domain: string,
    serviceName: string
  ): Promise<HostingWebTask> => {
    return this.ovh.request(
      'POST',
      `/hosting/web/${serviceName}/attachedDomain/${domain}/purgeCache`
    );
  };

  /** Restart the virtual host of the attached domain */
  postWebAttachedDomainRestartByServiceNameAndDomain = (
    domain: string,
    serviceName: string
  ): Promise<HostingWebTask> => {
    return this.ovh.request('POST', `/hosting/web/${serviceName}/attachedDomain/${domain}/restart`);
  };

  /** List configurations available for current hosting */
  listWebAvailableConfigurationsByServiceName = (
    serviceName: string
  ): Promise<HostingWebConfigurationVersionEnum[]> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/availableConfigurations`);
  };

  /** History of your hosting boost */
  getWebBoostHistoryByServiceName = (serviceName: string): Promise<Date[]> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/boostHistory`);
  };

  /** Get this object properties */
  getWebBoostHistoryByServiceNameAndDate = (
    date: Date,
    serviceName: string
  ): Promise<HostingWebBoostHistory> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/boostHistory/${date}`);
  };

  /** Get this object properties */
  getWebCdnByServiceName = (serviceName: string): Promise<HostingWebCdn> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/cdn`);
  };

  /** List available options for a Shared CDN service */
  listWebCdnAvailableOptionsByServiceName = (
    serviceName: string
  ): Promise<CdnAvailableOptions[]> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/cdn/availableOptions`);
  };

  /** List all domains for a Shared CDN service */
  listWebCdnDomainByServiceName = (serviceName: string): Promise<CdnDomain[]> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/cdn/domain`);
  };

  /** Get details for a domain on a Shared CDN service */
  getWebCdnDomainByServiceNameAndDomainName = (
    serviceName: string,
    domainName: string
  ): Promise<CdnDomain> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/cdn/domain/${domainName}`);
  };

  /** Generate URL to logs archive */
  getWebCdnDomainLogsByServiceNameAndDomainName = (
    serviceName: string,
    domainName: string
  ): Promise<CdnLogs> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/cdn/domain/${domainName}/logs`);
  };

  /** List all options for a domain */
  listWebCdnDomainOptionByServiceNameAndDomainName = (
    serviceName: string,
    domainName: string
  ): Promise<CdnDomainOption[]> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/cdn/domain/${domainName}/option`);
  };

  /** Add an option on a domain */
  addWebCdnDomainOptionByServiceNameAndDomainName = (
    serviceName: string,
    domainName: string,
    body: CdnDomainAddOption
  ): Promise<CdnDomainOption> => {
    return this.ovh.request(
      'POST',
      `/hosting/web/${serviceName}/cdn/domain/${domainName}/option`,
      body
    );
  };

  /** Remove or Reset an option to his default value */
  deleteWebCdnDomainOptionByServiceNameAndDomainNameAndOptionName = (
    serviceName: string,
    domainName: string,
    optionName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/hosting/web/${serviceName}/cdn/domain/${domainName}/option/${optionName}`
    );
  };

  /** Get details for an option on a domain */
  getWebCdnDomainOptionByServiceNameAndDomainNameAndOptionName = (
    serviceName: string,
    domainName: string,
    optionName: string
  ): Promise<CdnDomainOption> => {
    return this.ovh.request(
      'GET',
      `/hosting/web/${serviceName}/cdn/domain/${domainName}/option/${optionName}`
    );
  };

  /** Update an option on a domain */
  updateWebCdnDomainOptionByServiceNameAndDomainNameAndOptionName = (
    serviceName: string,
    domainName: string,
    optionName: string,
    body: CdnDomainOption
  ): Promise<CdnDomainOption> => {
    return this.ovh.request(
      'PUT',
      `/hosting/web/${serviceName}/cdn/domain/${domainName}/option/${optionName}`,
      body
    );
  };

  /** Flush cache content on CDN for a domain */
  postWebCdnDomainPurgeByServiceNameAndDomainName = (
    serviceName: string,
    domainName: string
  ): Promise<CdnOperation> => {
    return this.ovh.request('POST', `/hosting/web/${serviceName}/cdn/domain/${domainName}/purge`);
  };

  /** Trigger a refresh for a domain */
  postWebCdnDomainRefreshByServiceNameAndDomainName = (
    serviceName: string,
    domainName: string
  ): Promise<CdnOperation> => {
    return this.ovh.request('POST', `/hosting/web/${serviceName}/cdn/domain/${domainName}/refresh`);
  };

  /** Get CDN statistics for a domain */
  getWebCdnDomainStatisticsByServiceNameAndDomainName = (
    serviceName: string,
    domainName: string
  ): Promise<CdnDomainStatistics[]> => {
    return this.ovh.request(
      'GET',
      `/hosting/web/${serviceName}/cdn/domain/${domainName}/statistics`
    );
  };

  /** List all operations for a Shared CDN service */
  listWebCdnOperationByServiceName = (serviceName: string): Promise<CdnOperation[]> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/cdn/operation`);
  };

  /** Get details for a Shared CDN operation */
  getWebCdnOperationByServiceNameAndId = (
    serviceName: string,
    id: number
  ): Promise<CdnOperation> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/cdn/operation/${id}`);
  };

  /** Get this object properties */
  getWebCdnServiceInfosByServiceName = (serviceName: string): Promise<ServicesService> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/cdn/serviceInfos`);
  };

  /** Alter this object properties */
  updateWebCdnServiceInfosUpdateByServiceName = (
    serviceName: string,
    body: { renew: ServiceRenewType }
  ): Promise<void> => {
    return this.ovh.request('POST', `/hosting/web/${serviceName}/cdn/serviceInfosUpdate`, body);
  };

  /** Terminate your cdn sub service */
  postWebCdnTerminateByServiceName = (serviceName: string): Promise<string> => {
    return this.ovh.request('POST', `/hosting/web/${serviceName}/cdn/terminate`);
  };

  /** Launch a contact change procedure */
  launchWebChangeContactByServiceName = (
    serviceName: string,
    body: { contactAdmin?: string; contactBilling?: string; contactTech?: string }
  ): Promise<number[]> => {
    return this.ovh.request('POST', `/hosting/web/${serviceName}/changeContact`, body);
  };

  /** Get this object properties */
  getWebConfigurationByServiceName = (serviceName: string): Promise<HostingWebConfiguration> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/configuration`);
  };

  /** Alter this object properties */
  updateWebConfigurationByServiceName = (
    serviceName: string,
    body: HostingWebConfiguration
  ): Promise<void> => {
    return this.ovh.request('PUT', `/hosting/web/${serviceName}/configuration`, body);
  };

  /** Confirm termination of your service */
  confirmWebTerminationByServiceName = (
    serviceName: string,
    body: {
      commentary?: string;
      futureUse?: ServiceTerminationFutureUseEnum;
      reason?: ServiceTerminationReasonEnum;
      token: string;
    }
  ): Promise<string> => {
    return this.ovh.request('POST', `/hosting/web/${serviceName}/confirmTermination`, body);
  };

  /** Crons on your webhosting */
  getWebCronByServiceName = (serviceName: string): Promise<number[]> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/cron`);
  };

  /** Create new cron */
  createWebCronByServiceName = (
    serviceName: string,
    body: HostingWebCron
  ): Promise<HostingWebPublicTask> => {
    return this.ovh.request('POST', `/hosting/web/${serviceName}/cron`, body);
  };

  /** Delete cron */
  deleteWebCronByServiceNameAndId = (
    id: number,
    serviceName: string
  ): Promise<HostingWebPublicTask> => {
    return this.ovh.request('DELETE', `/hosting/web/${serviceName}/cron/${id}`);
  };

  /** Get cron by id */
  getWebCronByServiceNameAndId = (id: number, serviceName: string): Promise<HostingWebCron> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/cron/${id}`);
  };

  /** Update cron */
  updateWebCronByServiceNameAndId = (
    id: number,
    serviceName: string,
    body: HostingWebCron
  ): Promise<string> => {
    return this.ovh.request('PUT', `/hosting/web/${serviceName}/cron/${id}`, body);
  };

  /** Get the list of supported languages by web domain */
  getWebCronAvailableLanguageByServiceName = (
    serviceName: string
  ): Promise<HostingWebLanguagesEnum[]> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/cronAvailableLanguage`);
  };

  /** Databases linked to your hosting */
  getWebDatabaseByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/database`);
  };

  /** Install new database */
  postWebDatabaseByServiceName = (
    serviceName: string,
    body: {
      capabilitie: HostingWebDatabaseDatabaseCapabilitiesTypeEnum;
      password?: string;
      quota?: HostingWebDatabaseExtraSqlQuotaEnum;
      type: HostingWebDatabaseDatabaseCreationTypeEnum;
      user: string;
      version?: HostingWebDatabaseVersionEnum;
    }
  ): Promise<HostingWebTask> => {
    return this.ovh.request('POST', `/hosting/web/${serviceName}/database`, body);
  };

  /** Delete database */
  deleteWebDatabaseByServiceNameAndName = (
    name: string,
    serviceName: string
  ): Promise<HostingWebTask> => {
    return this.ovh.request('DELETE', `/hosting/web/${serviceName}/database/${name}`);
  };

  /** Get this object properties */
  getWebDatabaseByServiceNameAndName = (
    name: string,
    serviceName: string
  ): Promise<HostingWebDatabase> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/database/${name}`);
  };

  /** Get available capabilities for this database */
  getWebDatabaseCapabilitiesByServiceNameAndName = (
    name: string,
    serviceName: string
  ): Promise<HostingWebDatabaseDatabaseCapabilities> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/database/${name}/capabilities`);
  };

  /** Request a password change */
  postWebDatabaseChangePasswordByServiceNameAndName = (
    name: string,
    serviceName: string,
    body: { password: string }
  ): Promise<HostingWebTask> => {
    return this.ovh.request(
      'POST',
      `/hosting/web/${serviceName}/database/${name}/changePassword`,
      body
    );
  };

  /** Dump available for your databases */
  getWebDatabaseDumpByServiceNameAndName = (
    name: string,
    serviceName: string
  ): Promise<number[]> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/database/${name}/dump`);
  };

  /** Request the dump from your database */
  postWebDatabaseDumpByServiceNameAndName = (
    name: string,
    serviceName: string,
    body: { date: HostingWebDatabaseDumpDateEnum; sendEmail?: boolean }
  ): Promise<HostingWebTask> => {
    return this.ovh.request('POST', `/hosting/web/${serviceName}/database/${name}/dump`, body);
  };

  /** Delete dump before expiration date */
  deleteWebDatabaseDumpByServiceNameAndNameAndId = (
    id: number,
    name: string,
    serviceName: string
  ): Promise<HostingWebTask> => {
    return this.ovh.request('DELETE', `/hosting/web/${serviceName}/database/${name}/dump/${id}`);
  };

  /** Get this object properties */
  getWebDatabaseDumpByServiceNameAndNameAndId = (
    id: number,
    name: string,
    serviceName: string
  ): Promise<HostingWebDatabaseDump> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/database/${name}/dump/${id}`);
  };

  /** Request the restore from this dump */
  postWebDatabaseDumpRestoreByServiceNameAndNameAndId = (
    id: number,
    name: string,
    serviceName: string
  ): Promise<HostingWebTask> => {
    return this.ovh.request(
      'POST',
      `/hosting/web/${serviceName}/database/${name}/dump/${id}/restore`
    );
  };

  /** Import a dump from an specific file uploaded with /me/documents */
  postWebDatabaseImportByServiceNameAndName = (
    name: string,
    serviceName: string,
    body: { documentId: string; flushDatabase?: boolean; sendEmail?: boolean }
  ): Promise<HostingWebTask> => {
    return this.ovh.request('POST', `/hosting/web/${serviceName}/database/${name}/import`, body);
  };

  /** Request specific operation for your database */
  postWebDatabaseRequestByServiceNameAndName = (
    name: string,
    serviceName: string,
    body: { action: HostingWebDatabaseRequestActionEnum }
  ): Promise<HostingWebTask> => {
    return this.ovh.request('POST', `/hosting/web/${serviceName}/database/${name}/request`, body);
  };

  /** Request the restore from your database backup */
  postWebDatabaseRestoreByServiceNameAndName = (
    name: string,
    serviceName: string,
    body: { date: HostingWebDatabaseDumpDateEnum; sendEmail?: boolean }
  ): Promise<HostingWebTask> => {
    return this.ovh.request('POST', `/hosting/web/${serviceName}/database/${name}/restore`, body);
  };

  /** Get statistics about this database */
  getWebDatabaseStatisticsByServiceNameAndName = (
    name: string,
    serviceName: string
  ): Promise<ComplexTypeChartTimestampValue> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/database/${name}/statistics`);
  };

  /** List available database type */
  listWebDatabaseAvailableTypeByServiceName = (
    serviceName: string
  ): Promise<HostingWebDatabaseDatabaseTypeEnum[]> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/databaseAvailableType`);
  };

  /** List available database version following a type */
  listWebDatabaseAvailableVersionByServiceName = (
    serviceName: string
  ): Promise<HostingWebDatabaseAvailableVersionStruct> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/databaseAvailableVersion`);
  };

  /** List available database you can install */
  listWebDatabaseCreationCapabilitiesByServiceName = (
    serviceName: string
  ): Promise<HostingWebDatabaseCreationDatabaseCapabilities[]> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/databaseCreationCapabilities`);
  };

  /** Dumps linked to your hosting */
  getWebDumpByServiceName = (serviceName: string): Promise<number[]> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/dump`);
  };

  /** Delete dump before expiration date */
  deleteWebDumpByServiceNameAndId = (id: number, serviceName: string): Promise<HostingWebTask> => {
    return this.ovh.request('DELETE', `/hosting/web/${serviceName}/dump/${id}`);
  };

  /** Get this object properties */
  getWebDumpByServiceNameAndId = (id: number, serviceName: string): Promise<HostingWebDump> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/dump/${id}`);
  };

  /** Get this object properties */
  getWebEmailByServiceName = (serviceName: string): Promise<HostingWebEmail> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/email`);
  };

  /** Alter this object properties */
  updateWebEmailByServiceName = (serviceName: string, body: HostingWebEmail): Promise<void> => {
    return this.ovh.request('PUT', `/hosting/web/${serviceName}/email`, body);
  };

  /** Request the last bounces */
  getWebEmailBouncesByServiceName = (serviceName: string): Promise<HostingWebMailBounce[]> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/email/bounces`);
  };

  /** Request specific operation for your email */
  postWebEmailRequestByServiceName = (
    serviceName: string,
    body: { action: HostingWebMailActionEnum }
  ): Promise<string> => {
    return this.ovh.request('POST', `/hosting/web/${serviceName}/email/request`, body);
  };

  /** Request the history volume of email sent */
  getWebEmailVolumesByServiceName = (
    serviceName: string
  ): Promise<HostingWebMailVolumeHistory[]> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/email/volumes`);
  };

  /** Mail service linked to webhosting */
  getWebEmailOptionByServiceName = (serviceName: string): Promise<number[]> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/emailOption`);
  };

  /** Get this object properties */
  getWebEmailOptionByServiceNameAndId = (
    id: number,
    serviceName: string
  ): Promise<HostingWebEmailoption> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/emailOption/${id}`);
  };

  /** Get the service properties */
  getWebEmailOptionServiceInfosByServiceNameAndId = (
    id: number,
    serviceName: string
  ): Promise<ServicesService> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/emailOption/${id}/serviceInfos`);
  };

  /** Terminate your email sub service */
  postWebEmailOptionTerminateByServiceNameAndId = (
    id: number,
    serviceName: string
  ): Promise<string> => {
    return this.ovh.request('POST', `/hosting/web/${serviceName}/emailOption/${id}/terminate`);
  };

  /** Environment variables set on your webhosting */
  getWebEnvVarByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/envVar`);
  };

  /** Set a variable to this hosting */
  postWebEnvVarByServiceName = (
    serviceName: string,
    body: { key: string; type: HostingWebEnvVarTypeEnum; value: string }
  ): Promise<HostingWebTask> => {
    return this.ovh.request('POST', `/hosting/web/${serviceName}/envVar`, body);
  };

  /** Remove variable from hosting */
  deleteWebEnvVarByServiceNameAndKey = (
    key: string,
    serviceName: string
  ): Promise<HostingWebTask> => {
    return this.ovh.request('DELETE', `/hosting/web/${serviceName}/envVar/${key}`);
  };

  /** Get this object properties */
  getWebEnvVarByServiceNameAndKey = (
    key: string,
    serviceName: string
  ): Promise<HostingWebEnvVar> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/envVar/${key}`);
  };

  /** Alter this object properties */
  updateWebEnvVarByServiceNameAndKey = (
    key: string,
    serviceName: string,
    body: HostingWebEnvVar
  ): Promise<void> => {
    return this.ovh.request('PUT', `/hosting/web/${serviceName}/envVar/${key}`, body);
  };

  /** Sqlperso linked to your hosting */
  getWebExtraSqlPersoByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/extraSqlPerso`);
  };

  /** Get this object properties */
  getWebExtraSqlPersoByServiceNameAndName = (
    name: string,
    serviceName: string
  ): Promise<HostingWebExtrasqlperso> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/extraSqlPerso/${name}`);
  };

  /** Get databases linked with this option */
  getWebExtraSqlPersoDatabasesByServiceNameAndName = (
    name: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/extraSqlPerso/${name}/databases`);
  };

  /** Get this object properties */
  getWebExtraSqlPersoServiceInfosByServiceNameAndName = (
    name: string,
    serviceName: string
  ): Promise<ServicesService> => {
    return this.ovh.request(
      'GET',
      `/hosting/web/${serviceName}/extraSqlPerso/${name}/serviceInfos`
    );
  };

  /** Alter this object properties */
  updateWebExtraSqlPersoServiceInfosUpdateByServiceNameAndName = (
    name: string,
    serviceName: string,
    body: { renew: ServiceRenewType }
  ): Promise<void> => {
    return this.ovh.request(
      'POST',
      `/hosting/web/${serviceName}/extraSqlPerso/${name}/serviceInfosUpdate`,
      body
    );
  };

  /** Terminate your extraSqlPerso sub service */
  postWebExtraSqlPersoTerminateByServiceNameAndName = (
    name: string,
    serviceName: string
  ): Promise<string> => {
    return this.ovh.request('POST', `/hosting/web/${serviceName}/extraSqlPerso/${name}/terminate`);
  };

  /** Freedom linked to this hosting account */
  getWebFreedomByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/freedom`);
  };

  /** Delete the freedom */
  deleteWebFreedomByServiceNameAndDomain = (domain: string, serviceName: string): Promise<void> => {
    return this.ovh.request('DELETE', `/hosting/web/${serviceName}/freedom/${domain}`);
  };

  /** Get this object properties */
  getWebFreedomByServiceNameAndDomain = (
    domain: string,
    serviceName: string
  ): Promise<HostingWebFreedom> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/freedom/${domain}`);
  };

  /** User of multidomain independent allowed on your hosting */
  getWebIndyByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/indy`);
  };

  /** Get this object properties */
  getWebIndyByServiceNameAndLogin = (
    login: string,
    serviceName: string
  ): Promise<HostingWebIndy> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/indy/${login}`);
  };

  /** Local SEO accounts associated to the hosting */
  getWebLocalSeoAccountByServiceName = (serviceName: string): Promise<number[]> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/localSeo/account`);
  };

  /** Get this object properties */
  getWebLocalSeoAccountByServiceNameAndId = (
    id: number,
    serviceName: string
  ): Promise<HostingWebLocalSeoAccount> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/localSeo/account/${id}`);
  };

  /** Login this location for SSO */
  postWebLocalSeoAccountLoginByServiceNameAndId = (
    id: number,
    serviceName: string
  ): Promise<string> => {
    return this.ovh.request('POST', `/hosting/web/${serviceName}/localSeo/account/${id}/login`);
  };

  /** Check email availability for a local SEO order */
  checkWebLocalSeoEmailAvailabilityByServiceName = (
    serviceName: string
  ): Promise<HostingWebLocalSeoEmailAvailability> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/localSeo/emailAvailability`);
  };

  /** Local SEO locations associated to the hosting */
  getWebLocalSeoLocationByServiceName = (serviceName: string): Promise<number[]> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/localSeo/location`);
  };

  /** Get this object properties */
  getWebLocalSeoLocationByServiceNameAndId = (
    id: number,
    serviceName: string
  ): Promise<HostingWebLocalSeoLocation> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/localSeo/location/${id}`);
  };

  /** Get this object properties */
  getWebLocalSeoLocationServiceInfosByServiceNameAndId = (
    id: number,
    serviceName: string
  ): Promise<ServicesService> => {
    return this.ovh.request(
      'GET',
      `/hosting/web/${serviceName}/localSeo/location/${id}/serviceInfos`
    );
  };

  /** Alter this object properties */
  updateWebLocalSeoLocationServiceInfosUpdateByServiceNameAndId = (
    id: number,
    serviceName: string,
    body: { renew: ServiceRenewType }
  ): Promise<void> => {
    return this.ovh.request(
      'POST',
      `/hosting/web/${serviceName}/localSeo/location/${id}/serviceInfosUpdate`,
      body
    );
  };

  /** Terminate a local SEO sub service */
  postWebLocalSeoLocationTerminateByServiceNameAndId = (
    id: number,
    serviceName: string
  ): Promise<string> => {
    return this.ovh.request(
      'POST',
      `/hosting/web/${serviceName}/localSeo/location/${id}/terminate`
    );
  };

  /** Module installed on your hosting */
  getWebModuleByServiceName = (serviceName: string): Promise<number[]> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/module`);
  };

  /** Install a new module */
  postWebModuleByServiceName = (
    serviceName: string,
    body: {
      adminName?: string;
      adminPassword?: string;
      dependencies?: HostingWebModuleDependencyType[];
      domain?: string;
      language?: HostingWebModuleLanguageEnum;
      moduleId: number;
      path?: string;
    }
  ): Promise<HostingWebTask> => {
    return this.ovh.request('POST', `/hosting/web/${serviceName}/module`, body);
  };

  /** Delete a module installed */
  deleteWebModuleByServiceNameAndId = (
    id: number,
    serviceName: string
  ): Promise<HostingWebTask> => {
    return this.ovh.request('DELETE', `/hosting/web/${serviceName}/module/${id}`);
  };

  /** Get this object properties */
  getWebModuleByServiceNameAndId = (id: number, serviceName: string): Promise<HostingWebModule> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/module/${id}`);
  };

  /** Generate a new admin password for your module */
  postWebModuleChangePasswordByServiceNameAndId = (
    id: number,
    serviceName: string
  ): Promise<HostingWebTask> => {
    return this.ovh.request('POST', `/hosting/web/${serviceName}/module/${id}/changePassword`);
  };

  /** Configuration used on your hosting */
  getWebOvhConfigByServiceName = (serviceName: string): Promise<number[]> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/ovhConfig`);
  };

  /** Get this object properties */
  getWebOvhConfigByServiceNameAndId = (
    id: number,
    serviceName: string
  ): Promise<HostingWebOvhConfig> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/ovhConfig/${id}`);
  };

  /** Apply a new configuration on this path */
  postWebOvhConfigChangeConfigurationByServiceNameAndId = (
    id: number,
    serviceName: string,
    body: {
      container?: HostingWebOvhconfigContainerEnum;
      engineName?: HostingWebOvhConfigEngineNameEnum;
      engineVersion?: HostingWebOvhConfigAvailableEngineVersionEnum;
      environment?: HostingWebOvhConfigEnvironmentEnum;
      httpFirewall?: HostingWebOvhConfigHttpFirewallEnum;
    }
  ): Promise<HostingWebTask> => {
    return this.ovh.request(
      'POST',
      `/hosting/web/${serviceName}/ovhConfig/${id}/changeConfiguration`,
      body
    );
  };

  /** Rollback to an old configuration */
  postWebOvhConfigRollbackByServiceNameAndId = (
    id: number,
    serviceName: string,
    body: { rollbackId: number }
  ): Promise<HostingWebTask> => {
    return this.ovh.request('POST', `/hosting/web/${serviceName}/ovhConfig/${id}/rollback`, body);
  };

  /** Get the list of versions and container image available on your hosting */
  getWebOvhConfigCapabilitiesByServiceName = (
    serviceName: string
  ): Promise<HostingWebOvhConfigCapabilities[]> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/ovhConfigCapabilities`);
  };

  /** Get recommended values on ovhConfig file */
  getWebOvhConfigRecommendedValuesByServiceName = (
    serviceName: string
  ): Promise<HostingWebOvhConfigRecommendedValues> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/ovhConfigRecommendedValues`);
  };

  /** Synchronize the configuration listing with content on your hosting */
  postWebOvhConfigRefreshByServiceName = (serviceName: string): Promise<HostingWebTask> => {
    return this.ovh.request('POST', `/hosting/web/${serviceName}/ovhConfigRefresh`);
  };

  /** Own Logs linked to your hosting */
  getWebOwnLogsByServiceName = (serviceName: string): Promise<number[]> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/ownLogs`);
  };

  /** Get this object properties */
  getWebOwnLogsByServiceNameAndId = (
    id: number,
    serviceName: string
  ): Promise<HostingWebOwnLogs> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/ownLogs/${id}`);
  };

  /** User allowed to connect into your logs interface */
  getWebOwnLogsUserLogsByServiceNameAndId = (
    id: number,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/ownLogs/${id}/userLogs`);
  };

  /** Create new userLogs */
  createWebOwnLogsUserLogsByServiceNameAndId = (
    id: number,
    serviceName: string,
    body: { description: string; login: string; ownLogsId?: number; password: string }
  ): Promise<string> => {
    return this.ovh.request('POST', `/hosting/web/${serviceName}/ownLogs/${id}/userLogs`, body);
  };

  /** Delete the userLogs */
  deleteWebOwnLogsUserLogsByServiceNameAndIdAndLogin = (
    id: number,
    login: string,
    serviceName: string
  ): Promise<string> => {
    return this.ovh.request(
      'DELETE',
      `/hosting/web/${serviceName}/ownLogs/${id}/userLogs/${login}`
    );
  };

  /** Get this object properties */
  getWebOwnLogsUserLogsByServiceNameAndIdAndLogin = (
    id: number,
    login: string,
    serviceName: string
  ): Promise<HostingWebUserLogs> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/ownLogs/${id}/userLogs/${login}`);
  };

  /** Alter this object properties */
  updateWebOwnLogsUserLogsByServiceNameAndIdAndLogin = (
    id: number,
    login: string,
    serviceName: string,
    body: HostingWebUserLogs
  ): Promise<void> => {
    return this.ovh.request(
      'PUT',
      `/hosting/web/${serviceName}/ownLogs/${id}/userLogs/${login}`,
      body
    );
  };

  /** Request a password change */
  postWebOwnLogsUserLogsChangePasswordByServiceNameAndIdAndLogin = (
    id: number,
    login: string,
    serviceName: string,
    body: { password: string }
  ): Promise<string> => {
    return this.ovh.request(
      'POST',
      `/hosting/web/${serviceName}/ownLogs/${id}/userLogs/${login}/changePassword`,
      body
    );
  };

  /** List available privateDatabase you can install */
  listWebPrivateDatabaseCreationCapabilitiesByServiceName = (
    serviceName: string
  ): Promise<HostingWebDatabaseCreationDatabaseCapabilities[]> => {
    return this.ovh.request(
      'GET',
      `/hosting/web/${serviceName}/privateDatabaseCreationCapabilities`
    );
  };

  /** List linked privateDatabases */
  listWebPrivateDatabasesByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/privateDatabases`);
  };

  /** Request specific operation for your hosting */
  postWebRequestByServiceName = (
    serviceName: string,
    body: { action: HostingWebRequestActionEnum }
  ): Promise<HostingWebTask> => {
    return this.ovh.request('POST', `/hosting/web/${serviceName}/request`, body);
  };

  /** Allows you to boost your offer. */
  postWebRequestBoostByServiceName = (
    serviceName: string,
    body: { offer?: HostingWebOfferEnum }
  ): Promise<HostingWebTask> => {
    return this.ovh.request('POST', `/hosting/web/${serviceName}/requestBoost`, body);
  };

  /** Restore this snapshot ALL CURRENT DATA WILL BE REPLACED BY YOUR SNAPSHOT */
  postWebRestoreSnapshotByServiceName = (
    serviceName: string,
    body: { backup: HostingWebBackupTypeEnum }
  ): Promise<HostingWebTask> => {
    return this.ovh.request('POST', `/hosting/web/${serviceName}/restoreSnapshot`, body);
  };

  /** List of runtime configurations to your hosting */
  listWebRuntimeByServiceName = (serviceName: string): Promise<number[]> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/runtime`);
  };

  /** Request the creation of a new runtime configuration */
  postWebRuntimeByServiceName = (
    serviceName: string,
    body: {
      appBootstrap?: string;
      appEnv?: HostingWebRuntimeEnvEnum;
      attachedDomains?: string[];
      isDefault?: boolean;
      name?: string;
      publicDir?: string;
      type?: HostingWebRuntimeTypeEnum;
    }
  ): Promise<HostingWebTask> => {
    return this.ovh.request('POST', `/hosting/web/${serviceName}/runtime`, body);
  };

  /** Delete a runtime configuration of an hosting */
  deleteWebRuntimeByServiceNameAndId = (
    id: number,
    serviceName: string
  ): Promise<HostingWebTask> => {
    return this.ovh.request('DELETE', `/hosting/web/${serviceName}/runtime/${id}`);
  };

  /** Get this object properties */
  getWebRuntimeByServiceNameAndId = (
    id: number,
    serviceName: string
  ): Promise<HostingWebRuntime> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/runtime/${id}`);
  };

  /** Alter this object properties */
  updateWebRuntimeByServiceNameAndId = (
    id: number,
    serviceName: string,
    body: HostingWebRuntime
  ): Promise<void> => {
    return this.ovh.request('PUT', `/hosting/web/${serviceName}/runtime/${id}`, body);
  };

  /** Get the attached domains linked to this runtime configuration */
  getWebRuntimeAttachedDomainsByServiceNameAndId = (
    id: number,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/runtime/${id}/attachedDomains`);
  };

  /** List available runtime configurations available backend types */
  listWebRuntimeAvailableTypesByServiceName = (
    serviceName: string
  ): Promise<HostingWebRuntimeTypeEnum[]> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/runtimeAvailableTypes`);
  };

  /** Get this object properties */
  getWebServiceInfosByServiceName = (serviceName: string): Promise<ServicesService> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/serviceInfos`);
  };

  /** Alter this object properties */
  updateWebServiceInfosByServiceName = (
    serviceName: string,
    body: ServicesService
  ): Promise<void> => {
    return this.ovh.request('PUT', `/hosting/web/${serviceName}/serviceInfos`, body);
  };

  /** Get hosted SSL properties */
  getWebSslByServiceName = (serviceName: string): Promise<HostingWebSSL> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/ssl`);
  };

  /** Delete the HostedSsl on your hosting */
  deleteWebSslByServiceName = (serviceName: string): Promise<HostingWebSSL> => {
    return this.ovh.request('DELETE', `/hosting/web/${serviceName}/ssl`);
  };

  /** Create the free default HostedSsl OR import your proper SSL on your hosting */
  createWebSslByServiceName = (
    serviceName: string,
    body: { certificate?: string; chain?: string; key?: string }
  ): Promise<HostingWebSSL> => {
    return this.ovh.request('POST', `/hosting/web/${serviceName}/ssl`, body);
  };

  /** Get list of domains linked to the hosted SSL */
  getWebSslDomainsByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/ssl/domains`);
  };

  /** Request the regeneration of your HostedSsl */
  postWebSslRegenerateByServiceName = (serviceName: string): Promise<HostingWebSSL> => {
    return this.ovh.request('POST', `/hosting/web/${serviceName}/ssl/regenerate`);
  };

  /** Get hosted SSL report properties */
  getWebSslReportByServiceName = (serviceName: string): Promise<HostingWebSslReport> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/ssl/report`);
  };

  /** Get statistics about this web hosting */
  getWebStatisticsByServiceName = (
    serviceName: string
  ): Promise<ComplexTypeChartTimestampValue> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/statistics`);
  };

  /** Tasks attached to your hosting */
  getWebTasksByServiceName = (serviceName: string): Promise<number[]> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/tasks`);
  };

  /** Get this object properties */
  getWebTasksByServiceNameAndId = (id: number, serviceName: string): Promise<HostingWebTask> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/tasks/${id}`);
  };

  /** Terminate your service */
  postWebTerminateByServiceName = (serviceName: string): Promise<string> => {
    return this.ovh.request('POST', `/hosting/web/${serviceName}/terminate`);
  };

  /** Use to link an external domain. ( This token has to be insert into a TXT field on your dns zone with ovhcontrol subdomain ) */
  getWebTokenByServiceName = (serviceName: string): Promise<string> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/token`);
  };

  /** User allowed to connect into your hosting */
  getWebUserByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/user`);
  };

  /** Create new ftp/ssh user */
  createWebUserByServiceName = (
    serviceName: string,
    body: { home: string; login: string; password: string; sshState?: HostingWebUserSshStateEnum }
  ): Promise<HostingWebTask> => {
    return this.ovh.request('POST', `/hosting/web/${serviceName}/user`, body);
  };

  /** Delete ftp/ssh user */
  deleteWebUserByServiceNameAndLogin = (
    login: string,
    serviceName: string
  ): Promise<HostingWebTask> => {
    return this.ovh.request('DELETE', `/hosting/web/${serviceName}/user/${login}`);
  };

  /** Get this object properties */
  getWebUserByServiceNameAndLogin = (
    login: string,
    serviceName: string
  ): Promise<HostingWebUser> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/user/${login}`);
  };

  /** Alter this object properties */
  updateWebUserByServiceNameAndLogin = (
    login: string,
    serviceName: string,
    body: HostingWebUser
  ): Promise<void> => {
    return this.ovh.request('PUT', `/hosting/web/${serviceName}/user/${login}`, body);
  };

  /** Request a password change */
  postWebUserChangePasswordByServiceNameAndLogin = (
    login: string,
    serviceName: string,
    body: { password: string }
  ): Promise<HostingWebTask> => {
    return this.ovh.request(
      'POST',
      `/hosting/web/${serviceName}/user/${login}/changePassword`,
      body
    );
  };

  /** User allowed to connect into your logs interface */
  getWebUserLogsByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/userLogs`);
  };

  /** Create new userLogs */
  createWebUserLogsByServiceName = (
    serviceName: string,
    body: { description: string; login: string; ownLogsId?: number; password: string }
  ): Promise<string> => {
    return this.ovh.request('POST', `/hosting/web/${serviceName}/userLogs`, body);
  };

  /** Delete the userLogs */
  deleteWebUserLogsByServiceNameAndLogin = (
    login: string,
    serviceName: string
  ): Promise<string> => {
    return this.ovh.request('DELETE', `/hosting/web/${serviceName}/userLogs/${login}`);
  };

  /** Get this object properties */
  getWebUserLogsByServiceNameAndLogin = (
    login: string,
    serviceName: string
  ): Promise<HostingWebUserLogs> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/userLogs/${login}`);
  };

  /** Alter this object properties */
  updateWebUserLogsByServiceNameAndLogin = (
    login: string,
    serviceName: string,
    body: HostingWebUserLogs
  ): Promise<void> => {
    return this.ovh.request('PUT', `/hosting/web/${serviceName}/userLogs/${login}`, body);
  };

  /** Request a password change */
  postWebUserLogsChangePasswordByServiceNameAndLogin = (
    login: string,
    serviceName: string,
    body: { password: string }
  ): Promise<string> => {
    return this.ovh.request(
      'POST',
      `/hosting/web/${serviceName}/userLogs/${login}/changePassword`,
      body
    );
  };

  /** Get a temporary token to access the your web hosting logs interface */
  getWebUserLogsTokenByServiceName = (serviceName: string): Promise<string> => {
    return this.ovh.request('GET', `/hosting/web/${serviceName}/userLogsToken`);
  };
}

export { HostingWebHandler };
